var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "change-password-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleInitialSubmit.apply(null, arguments)
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("global.words.password")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c("div", { staticClass: "row moregage-form" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _vm.isFirefox
                      ? _c("div", [
                          _c("input", {
                            staticStyle: { display: "none" },
                            attrs: { type: "text", "data-lpignore": "true" },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "password",
                              "data-lpignore": "true",
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "material-input",
                      {
                        staticClass: "reveal-password-wrapper",
                        attrs: {
                          label: _vm.$t("settings.accountTab.currentPassword"),
                          "label-for": "currentPassword",
                        },
                        model: {
                          value: _vm.currentPassword,
                          callback: function ($$v) {
                            _vm.currentPassword = $$v
                          },
                          expression: "currentPassword",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentPassword,
                              expression: "currentPassword",
                            },
                          ],
                          staticClass: "form-control form password-input",
                          attrs: {
                            id: "currentPassword",
                            type: "password",
                            name: "currentPassword",
                            placeholder: _vm.$t(
                              "settings.accountTab.currentPassword"
                            ),
                          },
                          domProps: { value: _vm.currentPassword },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentPassword = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fa fa-eye text-muted clickable reveal-password",
                          attrs: { id: "reveal-current-password" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "material-input",
                      {
                        staticClass: "reveal-password-wrapper",
                        attrs: {
                          label: _vm.$t("settings.accountTab.newPassword"),
                          "label-for": "newPassword",
                        },
                        model: {
                          value: _vm.newPassword,
                          callback: function ($$v) {
                            _vm.newPassword = $$v
                          },
                          expression: "newPassword",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newPassword,
                              expression: "newPassword",
                            },
                          ],
                          staticClass:
                            "material-input form-control form new-password password password-input",
                          attrs: {
                            id: "newPassword",
                            type: "password",
                            name: "newPassword",
                            placeholder: _vm.$t(
                              "settings.accountTab.newPassword"
                            ),
                          },
                          domProps: { value: _vm.newPassword },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newPassword = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fa fa-eye text-muted clickable reveal-password",
                          attrs: { id: "reveal-new-password" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "material-input",
                      {
                        staticClass: "reveal-password-wrapper",
                        attrs: {
                          label: _vm.$t("settings.accountTab.confirmPassword"),
                          "label-for": "confirmPassword",
                        },
                        model: {
                          value: _vm.confirmPassword,
                          callback: function ($$v) {
                            _vm.confirmPassword = $$v
                          },
                          expression: "confirmPassword",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirmPassword,
                              expression: "confirmPassword",
                            },
                          ],
                          staticClass:
                            "material-input form-control form required password-input",
                          attrs: {
                            id: "confirmPassword",
                            type: "password",
                            name: "confirmPassword",
                            placeholder: _vm.$t(
                              "settings.accountTab.confirmPassword"
                            ),
                          },
                          domProps: { value: _vm.confirmPassword },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirmPassword = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fa fa-eye text-muted clickable reveal-password",
                          attrs: { id: "reveal-confirm-password" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }